<template>
  <div class="menu-view">
    <div class="notFooterArea">
      <!-- 菜单1 全宽 -->
      <el-row class="menu-row1">
        <el-col :lg="{span: $view.span, offset: $view.offset}" :md="{span: 22, offset: 1}">
          <div class="menu-main">
            <div class="left hidden-xs-only firstTile" @click="routePath('/home')">
              欢迎光临安全评估检测公共服务平台
            </div>
            <div class="right">
              <el-popover placement="bottom" width="200" trigger="hover">
                <div v-if="images && images.url">
                  <img @click="$tool.open(images.linkUrl)" :src="$baseURL + '/common/service/getFile/' + images.url" :alt="images.name"
                    style="width: 100%; height: 100%; object-fit: cover; object-position: center; display: block; cursor: pointer">
                </div>
                <div class="row1Menu" slot="reference">微信公众号</div>
              </el-popover>

              <el-popover placement="bottom" width="300" trigger="hover">
                <div style="line-height: 30px;">
                  <div><strong>联系地址：</strong>北京市西城区广安门外大街甲397号机械工业仪器仪表综合技术经济研究所</div>
                  <div><strong>杨工：</strong>010-63490546</div>
                  <div><strong>朱工：</strong>010-63498711</div>
                </div>
                <div class="row1Menu" slot="reference">联系客服</div>
              </el-popover>

              <el-popover placement="bottom" width="300" trigger="hover">
                <div style="line-height: 30px;">
                  <div><strong>若您在访问和使用本网站期间有任何问题，可拨打下述电话进行沟通：</strong></div>
                  <div><strong>杨工：</strong>010-63490546</div>
                  <div><strong>朱工：</strong>010-63498711</div>
                </div>
                <div class="row1Menu" slot="reference" @click="routePath('/help')">帮助中心</div>
              </el-popover>

              <template v-if="!userLoaded">
                <div class="row1Menu" @click="routePath('/account/register')">注册</div>
                <div class="row1Menu" @click="routePath('/account/login')">登录</div>
              </template>

              <template v-if="userLoaded">
                <el-popover v-model="popoverVisible" popper-class="userMenuPopper" placement="bottom" width="150" trigger="hover">
                  <div class="userMenu">
                    <div class="menuItem" @click="routePath('/userinfo')">用户中心</div>
                    <hr style="width: 80px">
                    <div class="menuItem" @click="routePath('/mylesson')">我的培训</div>
                    <div class="menuItem" @click="routePath('/myproductbuy')">我的申请</div>
                    <div class="menuItem" @click="routePath('/myproduct')">我的工具集</div>
                    <hr style="width: 80px">
                    <div class="menuItem" @click="exitLogin()">退出登录</div>
                  </div>
                  <div class="row1Menu" slot="reference">
                    <i style="margin-right: 5px;" class="el-icon-user"></i>
                    {{user.name || user.phone}}
                    <span v-if="user && user.type !== 0">({{userTypes[user.type]}})</span>
                    <i style="margin-left: 5px;" class="el-icon-arrow-down"></i>
                  </div>
                </el-popover>
              </template>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 菜单2 全宽（含移动端抽屉） -->
      <el-row class="menu-row2">
        <el-col :lg="{span: $view.span, offset: $view.offset}" :md="{span: 22, offset: 1}">
          <div class="menu-main">
            <div class="left">
              <div class="logo" @click="routePath('/home')">
                <img :src="require('../assets/img/logo.png')" alt="功能安全中心">
              </div>
              <div class="title">
                <h1 class="titleText" title="功能安全中心" @click="routePath('/home')">功能安全中心</h1>
              </div>
              <div class="search"></div>
            </div>

            <div class="right">
              <!-- 桌面端：原横向菜单 -->
              <template v-if="!isMobile">
                <div v-for="(item, index) in menuList" :key="index" class="row2Menu" :class="{ xsMenu: $wd.w < 600 }" @mouseenter="hoverIndex = index"
                  @mouseleave="hoverIndex = null">
                  <div @click="item.children.length === 0 && routePath(item.menuPath, [item.menuId])">
                    {{ item.name }}
                  </div>
                  <div class="childMenu" v-if="item.children.length > 0 && hoverIndex === index">
                    <div class="menuArea">
                      <div class="child-item" v-for="(child, idx) in item.children" :key="'child' + idx" @click="goChild(item, child)">
                        <div>{{ child.name }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>

              <!-- 移动端：汉堡按钮 -->
              <template v-else>
                <el-button type="text" class="hamburger-btn" icon="el-icon-menu" circle @click="showMobileMenu = true" />
              </template>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 移动端抽屉菜单 -->
      <el-drawer :visible.sync="showMobileMenu" direction="rtl" size="60%" :with-header="false" :append-to-body="true" custom-class="mobile-drawer">
        <el-menu class="mobile-menu" :default-active="$route.path" unique-opened router @select="onSelectMenu">
          <template v-for="(item, idx) in menuList">
            <!-- 无二级 -->
            <el-menu-item v-if="item.children.length === 0" :key="'m-'+idx" :index="item.menuPath">
              {{ item.name }}
            </el-menu-item>

            <!-- 含二级 -->
            <el-submenu v-else :key="'s-'+idx" :index="item.menuPath">
              <template slot="title">{{ item.name }}</template>
              <el-menu-item v-for="(child, cidx) in item.children" :key="'c-'+idx+'-'+cidx" :index="item.menuPath + child.menuPath">
                {{ child.name }}
              </el-menu-item>
            </el-submenu>
          </template>
        </el-menu>
      </el-drawer>

      <!-- 主体内容区域 灵活 -->
      <el-row class="menu-row3">
        <transition name="slide-fade">
          <router-view></router-view>
        </transition>
      </el-row>
    </div>

    <!-- Footer 全宽 -->
    <el-row :class="{menuRow4: true, menuRow4Mini: $wd.w < 600}">
      <el-col :lg="{span: 9, offset: 4}" :md="{span: 12, offset: 1}" :xs="{span: 24, offset: 0}">
        <div class="left-content">
          <div class="content-info top">
            <div class="content-left">copyright@机械工业仪器仪表综合技术经济研究所</div>
            <div class="content-right">京ICP备13033097号-2</div>
          </div>
          <div class="content-info">单位地址：北京市西城区广安门外大街甲397号</div>
          <div class="content-info">
            <div class="content-left">联系电话：010-63490546、63498711</div>
            <div class="content-right">电子邮箱：fscn@instrnet.com</div>
          </div>
        </div>
      </el-col>

      <el-col :lg="{span: 5, offset: 2}" :md="{span: 10, offset: 1}" :xs="{span: 24, offset: 0}">
        <div class="right-content">
          <div class="content-info top">相关链接：</div>
          <div class="content-info" style="cursor: pointer" @click="windowOpen('https://www.itei.cn/')"><span>机械工业仪器仪表综合技术经济研究所</span></div>
          <div class="content-info" style="cursor: pointer" @click="windowOpen('http://www.cima.org.cn/tcjj.asp')"><span>全国工业过程测量控制和自动化标准化技术委员会</span></div>
          <!-- <el-link class="content-info" type="primary" :underline="false" href="https://www.itei.cn/" target="_blank">机械工业仪器仪表综合技术经济研究所</el-link>
          <el-link class="content-info" type="primary" :underline="false" href="http://www.cima.org.cn/tcjj.asp" target="_blank">全国工业过程测量控制和自动化标准化技术委员会</el-link> -->
        </div>
      </el-col>
    </el-row>

    <el-dialog title="通知" :visible.sync="alertDialog" :width="$wd.w < 900 ? '90%' : '50%'">
      <RichText :html="html"></RichText>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmIKnow">我已知晓，不再提示</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  data () {
    return {
      alertDialog: false,
      popoverVisible: false,
      hoverIndex: null,
      menuList: [
        { menuId: 1, name: '首页', menuPath: '/home', children: [] },
        {
          menuId: 2,
          name: '中心概况',
          menuPath: '/about',
          children: [
            { menuId: 21, name: '中心简介', menuPath: '/introduction' },
            { menuId: 22, name: '组织架构', menuPath: '/organization' },
            { menuId: 23, name: '主要业务', menuPath: '/business' }
          ]
        },
        {
          menuId: 3,
          name: '新闻动态',
          menuPath: '/news',
          children: [
            { menuId: 31, name: '中心新闻', menuPath: '/centerNews' },
            { menuId: 32, name: '行业新闻', menuPath: '/industryNews' },
            { menuId: 33, name: '中心公告', menuPath: '/centerAnnouncement' },
            { menuId: 34, name: '机构公告', menuPath: '/institutionAnnouncement' }
          ]
        },
        {
          menuId: 4,
          name: '功能安全',
          menuPath: '/product',
          children: [
            { menuId: 41, name: '系统级功能安全', menuPath: '/sfs' },
            { menuId: 42, name: '产品级功能安全', menuPath: '/pfs' },
            { menuId: 43, name: '软件测试服务', menuPath: '/st' }
          ]
        },
        {
          menuId: 5,
          name: '信息安全',
          menuPath: '/product',
          children: [
            { menuId: 51, name: '系统级信息安全', menuPath: '/sis' },
            { menuId: 52, name: '组件级信息安全', menuPath: '/cis' }
            // { menuId: 53, name: '信息安全咨询服务', menuPath: '/isc' }
          ]
        },
        {
          menuId: 6,
          name: '培训服务',
          menuPath: '/lesson',
          children: [
            { menuId: 61, name: '培训课程', menuPath: '/classes' },
            { menuId: 62, name: '技术分享', menuPath: '/resources' }
          ]
        },
        {
          menuId: 7,
          name: '证书查询',
          menuPath: '/cert',
          children: [
            { menuId: 71, name: '评估认证证书', menuPath: '/eval' },
            { menuId: 72, name: '人员培训证书', menuPath: '/train' }
          ]
        },
        { menuId: 8, name: '在线工具', menuPath: '/product/tool', children: [] }
      ],
      userTypes: {
        0: '普通用户',
        1: '企业管理员',
        2: '企业用户',
        3: '系统管理员'
      },
      searchWord: '',
      images: {},
      userLoaded: false,
      user: null,

      /* 新增：移动端抽屉状态 */
      showMobileMenu: false,
      html: '' // 公告通知
    }
  },
  computed: {
    /* 新增：断点判定，可按需将 768 调整为 600 以与 xsMenu 保持一致 */
    isMobile () {
      return this.$wd && this.$wd.w < 768
    }
  },
  mounted () {
    setTimeout(() => {
      if (this.$cookie.get('YZSNAME')) {
        this.$http.post('/user/service/getUser', {}).then((res) => {
          this.user = res.data
          this.userLoaded = true
        }).catch(() => {
          setTimeout(() => {
            this.exitLogin()
          }, 1000)
        })
      }
    }, 10)
    this.$http.post('/door/service/getImageByCode', ['home_weixin']).then((res) => {
      this.images = Object.values(res.data)[0][0]
    })
    if (!sessionStorage.getItem('alertDialog')) {
      this.$http.post('/door/service/getContent', { code: 'announcement' }).then((res) => {
        this.html = res.data.html
        const parser = new DOMParser()
        const doc = parser.parseFromString(this.html, 'text/html')
        const data = doc.body.textContent || ''
        if (data.length > 3) {
          this.alertDialog = true
        }
      })
    }
  },
  methods: {
    confirmIKnow () {
      sessionStorage.setItem('alertDialog', 'true')
      this.alertDialog = false
    },
    goChild (item, child) {
      this.routePath(item.menuPath + child.menuPath, [item.menuId, child.menuId])
      this.hoverIndex = null
      this.showMobileMenu = false
    },
    handSearch () {
      console.log(this.searchWord)
    },
    windowOpen (path) {
      window.open(path, '_blank')
    },
    routePath (menuPath, menuIds) {
      this.popoverVisible = false
      this.$router.push(menuPath)
    },
    exitLogin () {
      this.$cookie.set('YZSNAME', '', -1)
      this.$cookie.set('YZSTOKEN', '', -1)
      this.$cookie.set('YZSUSERID', '', -1)
      document.cookie.split(';').forEach(cookie => {
        const trimmedCookie = cookie.trim()
        if (trimmedCookie.startsWith('WORK_TOKEN')) {
          const cookieName = trimmedCookie.split('=')[0]
          this.$cookie.set(cookieName, '', -1)
        }
      })
      window.location.href = '/'
    },
    /* 新增：抽屉菜单选择逻辑（关闭抽屉并导航） */
    onSelectMenu (path) {
      this.showMobileMenu = false
      this.routePath(path)
    }
  }
}
</script>

<style lang="less" scoped>
.menu-view {
  position: relative;
  font-size: 14px;

  .notFooterArea {
    min-height: 100vh;
  }

  .menu-row1,
  .menu-row2 {
    .menu-main {
      position: relative;
      padding: 0 10px;
    }
    .right {
      position: absolute;
      top: 0;
      right: 0;
    }
  }

  .menu-row1 {
    height: 40px;
    line-height: 40px;
    background-color: #4155c6;
    color: #fff;
    font-weight: bold;
    .firstTile {
      cursor: pointer;
    }
    .row1Menu {
      display: inline-block;
      margin: 12px 0;
      padding: 0 12px;
      height: 16px;
      line-height: 16px;
      border-right: 1px solid #fff;
      cursor: pointer;
    }
  }

  .menu-row2 {
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid #000;
    font-weight: bold;
    user-select: none;

    .row2Menu {
      display: inline-block;
      margin: 12px 0;
      padding: 0 10px;
      height: 16px;
      line-height: 16px;
      cursor: pointer;
      position: relative;

      &:hover {
        color: #4155c6;
      }

      .childMenu {
        position: absolute;
        top: 13px;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
        z-index: 99999;
        width: 120px;
        color: #000;

        .menuArea {
          margin-top: 20px;
          background-color: rgba(255, 255, 255, 0.85);

          .child-item {
            line-height: 30px;
            padding: 5px 0;
            border-bottom: 1px solid #eee;
            border-left: 1px solid #eee;
            border-right: 1px solid #eee;

            &:hover {
              color: #4155c6;
              background-color: #eeeeee;
            }
            &:active {
              background-color: #ccc;
            }
          }
        }
      }
    }

    .xsMenu {
      font-size: 10px;
      padding: 0 5px;
    }

    .logo {
      display: inline-block;
      height: 50px;
      padding: 10px;
      vertical-align: top;
      cursor: pointer;
      img {
        height: 100%;
      }
    }

    .title {
      display: inline-block;
      height: 30px;
      position: relative;
      margin-left: 5px;
      line-height: 30px;

      .titleText {
        display: inline-block;
        font-weight: bold;
        margin-right: 15px;
        font-size: 20px;
        margin: 0 15px 0 0;
        padding: 0;
        cursor: pointer;
      }
    }

    .hamburger-btn {
      margin: 6px 8px 0 0;
    }
  }

  .menuRow4 {
    width: 100%;
    background-color: #4654c4;
    color: #fff;
    font-size: 14px;
    line-height: 30px;
    vertical-align: top;
    padding: 20px;

    .left-content {
      width: 480px;
      margin: 0 auto;
    }
    .right-content {
      width: 310px;
      margin: 0 auto;
    }

    .content-info {
      position: relative;
      height: 30px;
      color: #fff;
      text-align: left;
      &:hover {
        span {
          color: #d6e2ff;
        }
      }
    }
    .top {
      border-bottom: 1px solid #fff;
      margin-bottom: 5px;
    }
    .content-left {
      height: 30px;
      line-height: 30px;
    }
    .content-right {
      position: absolute;
      top: 0;
      right: 0;
      height: 30px;
    }
  }

  .menuRow4Mini {
    font-size: 12px;
    padding: 20px 5px;
    .left-content {
      width: 400px;
    }
    .right-content {
      width: 400px;
    }
  }

  .slide-fade-enter-active {
    transition: all 0.5s ease;
  }
  .slide-fade-enter,
  .slide-fade-leave-to {
    transform: translateY(100px);
    opacity: 0;
  }
}

/* 移动端适配：为汉堡按钮预留空间并垂直对齐 */
@media (max-width: 767px) {
  .menu-row2 {
    height: 50px;
    .menu-main {
      padding-right: 56px;
    }
    .right {
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      align-items: center;
      height: 50px;
      line-height: 50px;
    }
  }
}

/* 深度覆盖抽屉内边距（append-to-body 时仍生效） */
::v-deep .mobile-drawer .el-drawer__body {
  padding: 12px 8px;
  overflow: auto;
}

.mobile-menu {
  border-right: none;
}

.userMenuPopper {
  .menuItem {
    line-height: 30px;
    padding: 5px 0;
    cursor: pointer;
    text-align: center;
    font-weight: bold;
    color: #333;
    user-select: none;

    &:hover {
      color: #3552d6;
    }
    &:active {
      color: #000;
    }
  }
}
</style>
